import { dark } from "@material-ui/core/styles/createPalette";

const brandTheme = {
    mainColor:'#15254F',
    shaddowColor: '#838ca9',
    secondaryColor:'#1CB167',
    backgroundColor: '#ebfbf6',
    fullSiteBackgroundColor: '#f1f7f5',
    errorColor:'#EF4444',
    buttonColor: '#15254F',
    buttonHoverColor:'#15254F',
    white:'#ffffff',
    black: '#2f2f2f',
    fieldColor: '#bdbdbd',
    footerBackGroundColor:'#d3d3d33b',
    headerBackGroundColor:'#d3d3d33b',
    sideBarColor: '#15254F',
    sideBarHoverColor: "#15254F",
    headerFontSize: "1.75rem",
    button2Color: "#15254F",
    lightBlack:'#000000cf',
    blue:"#0029ff",
    lightBlue:"#0029ff",
    rowColourBackground:'#00800042',
    rowRedColourBackground:'#1CB167',
    mehroon:'#15254F',
    font: {
        roboto: 'Roboto',
        poppins: 'Poppins',
        // hindFontSemiBold: 'Hind-SemiBold',
        // hindFontRegular: 'Hind-Regular',
        // hindFontMedium: 'Hind-Medium',
        // hindFontLight: 'Hind-Light',
        // bebaseNeueRegular: 'BebasNeue-Regular'
    },
    
};

export default brandTheme;
